import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getShareViaTwitterSelector } from 'common/selectors/index';
import { getBase64SharePathSelector } from '../selectors';
import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons';
import { ShareButton } from '../share-button';

export const TwitterButton = () => {
  const isFeatureEnabled = useSelector(getShareViaTwitterSelector);
  const params = useSelector(getBase64SharePathSelector(useParams()));
  const onClick = () => {
    window.open(`https://twitter.com/intent/tweet?text=${window.location.origin}/api/share?p=${params}`);
  };

  return (
    <ShareButton
      hidden={!isFeatureEnabled}
      dataE2e="twitter-button"
      onClick={onClick}
      icon={faTwitterSquare}
      label="Twitter"
    />
  );
};
